<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (compact) {
    <div class="etape-options-compact flex flex-column gap-1" role="list" aria-label="Options de soumission">
        @for (option of optionsAffichables(); track trackOption(option)) {
            <div
                class="etape-options-compact__line flex align-items-center gap-2 py-0.5 px-1 text-sm line-height-3 min-h-0"
                role="listitem"
                [class.etape-options-compact__line--selected]="estSelectionnee(option)">
                <span class="etape-options-compact__marker flex-shrink-0 w-1.25rem flex justify-content-center text-sm" aria-hidden="true">
                    @if (estSelectionnee(option)) {
                        <i class="pi pi-check-circle text-primary"></i>
                    } @else {
                        <i class="pi pi-circle text-color-secondary opacity-60" style="font-size: 0.65rem;"></i>
                    }
                </span>
                <span class="flex-1 min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                    {{ option.description || 'Sans description' }}
                </span>
                <span class="text-color-secondary white-space-nowrap flex-shrink-0">
                    {{ (option.montantPieces ?? 0) | number:'1.2-2' }} $
                    <span class="mx-1 opacity-50">·</span>
                    {{ (option.nbHeures ?? 0) | number:'1.2-2' }} h
                </span>
            </div>
        }
        @if (!optionsAffichables().length) {
            <span class="text-sm text-color-secondary py-0.5 px-1">Aucune variante</span>
        }
    </div>
} @else {
    <div class="etape-options-table-wrapper overflow-x-auto">
        <table class="etape-options-table w-full border-collapse">
            <thead>
                <tr>
                    <th class="text-left p-2" style="width: 40%">Description</th>
                    <th class="text-left p-2" style="width: 22%">Montant</th>
                    <th class="text-left p-2" style="width: 18%">Heures</th>
                    <th class="text-center p-2" style="width: 8rem">Retenue</th>
                    @if (!readonly) {
                        <th class="p-2" style="width: 4rem"></th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (option of options; track trackOption(option); let index = $index) {
                    <tr [class.etape-options-table__row-selected]="estSelectionnee(option)">
                        <td class="p-2 align-middle">
                            @if (readonly) {
                                <span [class.text-color-secondary]="!option.description" [class.font-italic]="!option.description">
                                    {{ option.description || 'Sans description' }}
                                </span>
                            } @else {
                                <input pInputText type="text"
                                    placeholder="Description de la variante"
                                    class="w-full"
                                    [(ngModel)]="option.description"
                                    (blur)="surChangement(index)"
                                    (focusin)="$event.target.select()" />
                            }
                        </td>
                        <td class="p-2 align-middle">
                            @if (readonly) {
                                @if (option.montantPieces != null) {
                                    {{ option.montantPieces | number:'1.2-2' }} $
                                } @else {
                                    <span class="text-color-secondary">—</span>
                                }
                            } @else {
                                <p-inputNumber
                                    class="w-full"
                                    [(ngModel)]="option.montantPieces"
                                    (onBlur)="surChangement(index)"
                                    mode="decimal"
                                    [minFractionDigits]="0"
                                    [maxFractionDigits]="2"
                                    [showClear]="true"
                                    suffix=" $"
                                    (focusin)="$event.target.select()" />
                            }
                        </td>
                        <td class="p-2 align-middle">
                            @if (readonly) {
                                @if (option.nbHeures != null) {
                                    {{ option.nbHeures | number:'1.2-2' }} h
                                } @else {
                                    <span class="text-color-secondary">—</span>
                                }
                            } @else {
                                <p-inputNumber
                                    class="w-full"
                                    mode="decimal"
                                    [(ngModel)]="option.nbHeures"
                                    (onBlur)="surChangement(index)"
                                    [showButtons]="false"
                                    [min]="0"
                                    [minFractionDigits]="0"
                                    [maxFractionDigits]="2"
                                    suffix=" h"
                                    (focusin)="$event.target.select()" />
                            }
                        </td>
                        <td class="p-2 text-center align-middle">
                            <p-radioButton
                                [name]="radioGroupName"
                                [value]="valeurRadio(option)"
                                [(ngModel)]="_optionSelectionnee"
                                [disabled]="(readonly || disabled || (option.description == '' && option.montantPieces == null && option.nbHeures == null)) && !modifySelection"
                                (click)="changementOption(option)">
                            </p-radioButton>
                        </td>
                        @if (!readonly && index != options.length - 1) {
                            <td class="p-2 text-center align-middle">
                                <p-button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    styleClass="p-button-text p-button-sm"
                                    (onClick)="removeOption(option)"
                                    [disabled]="options.length == 1">
                                </p-button>
                            </td>
                        }
                        @if (!readonly && index == options.length - 1) {
                            <td class="p-2"></td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
